import { takeLatest, all, select, put } from 'redux-saga/effects';
import LockedPasswordPanelActions from './actions';

import { FORM_ID } from '../index';
import { CKForm } from 'console-kit';

function* onLockedRequestHandler({ payload: { formRef } }) {
  yield put(CKForm.Actions.validateForm(FORM_ID));
  const isValid = yield select(CKForm.Selectors.isFormValid, FORM_ID);

  if (isValid) {
    formRef.method = 'post';
    formRef.submit();
  } else {
    yield put(LockedPasswordPanelActions.onLockedPasswordPanelFailure());
  }
}

function* authFormSagas() {
  yield all([takeLatest(LockedPasswordPanelActions.onLockedPasswordPanelRequest.getType(), onLockedRequestHandler)]);
}

export default authFormSagas;
